import React from 'react'


export default class extends React.Component {
    render() {

		return (

			<span className="loading-dots">
				<span>.</span>
				<span>.</span>
				<span>.</span>
			</span>
			
		)
	}
}



// WEBPACK FOOTER //
// ./src/js/components/Loaders/MiniLoader.js